import React, { useState } from 'react'
import Imgix from 'react-imgix'
import { Swiper, SwiperSlide } from 'swiper/react'
import { GalleryComponentProps } from './GalleryComponentProps'
import useStyles from './GalleryComponent.styles'

const GalleryComponent: React.FC<GalleryComponentProps> = ({
  title,
  images
}: GalleryComponentProps) => {
  const classes = useStyles()
  const [activeIndex, setActiveIndex] = useState(0)

  return (
    <div className={classes.gallery}>
      {title && <div className={classes.title}>{title}</div>}
      <Swiper
        className={classes.swiper}
        centeredSlides
        slidesPerView="auto"
        spaceBetween={20}
        slideToClickedSlide
        grabCursor
        onSlideChange={swiper => setActiveIndex(swiper.realIndex ?? swiper.activeIndex)}
        watchSlidesProgress
        breakpoints={{
          768: { spaceBetween: 30 },
          1200: { spaceBetween: 40 },
          1920: { spaceBetween: 70 }
        }}
      >
        {images.map((image, index) => (
          <SwiperSlide
            key={image.src}
            className={`${classes.slide} ${index === activeIndex ? classes.activeSlide : ''}`}
          >
            <Imgix className={classes.image} src={image.src} />
            {image.imageDesc && (
              <div className={classes.imageDesc}>{image.imageDesc}</div>
            )}
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  )
}

export default GalleryComponent
